import { useMutation, gql } from "@apollo/client"
import { REGION_FIELDS } from "./useQueryRegions"

const CREATE_REGION_MUTATION = gql`
  ${REGION_FIELDS}
  mutation CreateRegion($name: String!) {
    createRegion(name: $name) {
      ...RegionFields
    }
  }
`

const useMutationCreateRegion = () => useMutation(CREATE_REGION_MUTATION)

export { useMutationCreateRegion }
